"use strict";exports.__esModule=true;exports.default=void 0;var _default=function _default(x){return Array.isArray(x)};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/type/is-array.js
// module id = cMaL
// module chunks = 5